/* import __COLOCATED_TEMPLATE__ from './audio-opener.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { ref } from 'ember-ref-bucket';

const VALID_AUDIO_TYPES = ['audio/mpeg'];

export default class ConversationControlInserterAudioOpener extends Component {
  @service intercomEventService;
  @service intl;
  @service notificationsService;
  @service store;

  analyticsName = 'audio_inserter';

  @ref('inputElement') inputElement;

  @action
  handleClick(event) {
    this.intercomEventService.trackAnalyticsEvent({
      owner: 'inbox',
      action: 'clicked',
      object: this.analyticsName,
      place: 'inbox',
      context: this.analyticsName,
    });
  }

  @action
  handleChange(event) {
    let files = Array.from(event.target.files);
    let allValid = files.every((file) => VALID_AUDIO_TYPES.includes(file.type));
    if (files.length > 0 && allValid) {
      this.inputElement.value = '';
      this.args.controlsAPI?.actions.uploadAudio(files);
      this.args.inserterAPI?.actions.close();
    } else {
      this.notificationsService.notifyError(
        this.intl.t('calling.errors.calling-upload-audio-error'),
      );
    }
  }
}
